// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { isBankUploadDataSection } from '@client/banks/layouts/section-tabs/bank-upload-section-tabs';
import { useBankUploadData } from '@client/banks/providers/bank-upload-provider';
import type { BankUploadSection } from '@client/banks/types/bank-upload';
import type { DrawerTriggerProps } from '@shared/ui-kit/hooks/use-drawer';
import { useStepsData } from '@shared/ui-kit/hooks/use-steps';
import type { FC } from 'react';
import { useMemo } from 'react';

export interface BankUploadDrawerProps {
  Trigger: FC<DrawerTriggerProps>;
  drawerTestId?: string;
}

export const useBankUploadDrawer = ({
  Trigger,
  drawerTestId,
}: BankUploadDrawerProps) => {
  const { DrawerRenderer } = useBankUploadData();
  const { element, meta } = useStepsData();

  const showSectionTabs = useMemo(() => {
    const section = meta?.section as BankUploadSection | undefined;

    return isBankUploadDataSection(section);
  }, [meta?.section]);

  return {
    DrawerRenderer,
    Trigger,
    drawerTestId: drawerTestId ?? 'bank-upload-drawer',
    element,
    showSectionTabs,
  };
};
